/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Skips_ClutterInputs */

const en_why_listening_compare_skips_clutter = /** @type {(inputs: Why_Listening_Compare_Skips_ClutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skips clutter like footnotes and page numbers`)
};

const es_why_listening_compare_skips_clutter = /** @type {(inputs: Why_Listening_Compare_Skips_ClutterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omite el desorden, como notas al pie y números de página`)
};

/**
* | output |
* | --- |
* | "Skips clutter like footnotes and page numbers" |
*
* @param {Why_Listening_Compare_Skips_ClutterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_skips_clutter = /** @type {((inputs?: Why_Listening_Compare_Skips_ClutterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Skips_ClutterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_skips_clutter(inputs)
	return en_why_listening_compare_skips_clutter(inputs)
});